import ULThemeLink from "@/components/ULThemeLink";
import { getConsoleSignupUrl } from "@/utils/helpers/consoleUrls";

import { useLoginIdManager } from "../hooks/useLoginIdManager";

function Footer() {
  const { signupLink, texts, locales } = useLoginIdManager();

  // signupLink is only used to gate visibility — when Auth0 reports signup is
  // disabled for the tenant, no link is shown. When it is enabled, the link
  // points at the Lexara console's signup flow instead of Auth0's own screen.
  if (!signupLink) {
    return null;
  }

  return (
    <div className="mt-4 text-left">
      <span className="pr-1 text-body-text text-(length:--ul-theme-font-body-text-size) font-body">
        {texts?.signupActionText || locales?.footer?.signupActionText}
      </span>
      <ULThemeLink href={getConsoleSignupUrl()}>
        {texts?.signupActionLinkText || locales?.footer?.signupActionLinkText}
      </ULThemeLink>
    </div>
  );
}

export default Footer;
